import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'

const options = formFieldCommonOptions('FormInputDropdown', {
    validatorFunction(input) {
        return input
    }
})

export default options
